export enum TemplateKindType {
  WEBSITE = 'Website',
  HEADER = 'Header',
  FOOTER = 'Footer',
  PAGE = 'Page',
}
